















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SummaryCard extends Vue {
  @Prop({ required: true })
  private item!: any;

  @Prop({ required: true })
  private title!: string;
}
